import { of, from, Observable } from 'rxjs';

import { map, mergeMap, catchError } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { User } from '../shared/models';
import * as AuthActions from '../actions/auth.actions';
import { AuthService } from '../auth/services/auth.service';
import { UserService } from '../core/user.service';

@Injectable()
export class AuthEffects {
  constructor(
    private authService: AuthService,
    private userService: UserService,
    private actions$: Actions,
  ) {}

  // Listen for the 'LOGIN' action
  public login$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.AUTH_LOGIN),
      mergeMap((action: AuthActions.LoginAction) => {
        return from(
          this.authService.authenticate(
            action.payload.username,
            action.payload.password,
            action.payload.twofacode,
            undefined,
            action.payload.cfTurnstileToken,
          ),
        ).pipe(
          map((data) => new AuthActions.LoginSuccessAction(data)),
          catchError((err) => of(new AuthActions.LoginFailureAction(err))),
        );
      }),
    ),
  );

  public loginSSO$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.AUTH_LOGIN_SSO),
      mergeMap((action: AuthActions.LoginSSOAction) => {
        return from(this.authService.loginSSO(action.payload)).pipe(
          map((user) => new AuthActions.LoginSuccessAction(user)),
          catchError((err) => of(new AuthActions.LoginFailureAction(err))),
        );
      }),
    ),
  );

  public refresh$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.AUTH_REFRESH),
      mergeMap((action: AuthActions.RefreshAction) => {
        return from(this.userService.reload()).pipe(
          map((data) => {
            const user = new User().deserialize(data);
            return new AuthActions.UpdateAction(user);
          }),
          catchError((err) => {
            return of(new AuthActions.LoginFailureAction(err));
          }),
        );
      }),
    ),
  );
}
